import { ALOHA_SCROLL_CONTAINER_ID, SIMPLE_SCROLL_CONTAINER_ID } from '@apps/guest/routes/GuestSite/GuestSite.constants';
import { withWindow } from '@shared/utils/withWindow';
import { throttle } from 'lodash-es';
import { useEffect, useState } from 'react';

type UseScrollPastHeroOptions = Readonly<{
  threshold?: number;
}>;

export const useScrollPastHero = ({ threshold = 100 }: UseScrollPastHeroOptions = {}) => {
  const [isPastThreshold, setIsPastThreshold] = useState(false);

  useEffect(() => {
    return withWindow(global => {
      const target = global.document.getElementById(SIMPLE_SCROLL_CONTAINER_ID) || global.document.getElementById(ALOHA_SCROLL_CONTAINER_ID) || global;

      const handleScroll = throttle(() => {
        const scrollY = 'scrollY' in target ? target.scrollY : target.scrollTop;
        setIsPastThreshold(scrollY > threshold);
      }, 100);

      handleScroll();
      target.addEventListener('scroll', handleScroll, { passive: true });

      return () => {
        handleScroll.cancel();
        target.removeEventListener('scroll', handleScroll);
      };
    });
  }, [threshold]);

  return { isPastThreshold };
};
